import { CountyDto } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import { getAssignedServiceRegionsByEmployeeId } from "requests/region";
import responseHandler from "responseHandler";
import { connect } from "react-redux";
import MGrid, { MGridColumnDefinition } from "components/Shared/MGrid";


interface TerritoryAssignmentsCardProps {
  employeeId: number;
  //dispatch
  makeErrorToast: (text: string) => void;
}

const TerritoryAssignmentsCard = (props: TerritoryAssignmentsCardProps) => {

  const [assignedRegions, setAssignedRegions] = useState<CountyDto[]>([]);
  const [isFetchingRegions, setIsFetchingRegions] = useState<boolean>(true);

  const mounted = useRef<boolean>(true);

  const getRegions = () => {
    getAssignedServiceRegionsByEmployeeId(
      props.employeeId,
      (regions) => {
        setAssignedRegions(regions);
        setIsFetchingRegions(false);
      },
      mounted,
      () => {
        props.makeErrorToast("Failed to fetch assigned regions, please try again");
      }
    );
  }

  useEffect(() => {
    setIsFetchingRegions(true);
    getRegions();
  },
  [props.employeeId]);

  useEffect(() => { return () => { mounted.current = false; } }, []);

  const columnDefs: MGridColumnDefinition[] = [
    {
      key: "state",
      name: "State",
      dataSource: "state",
      sortable: true,
    },
    {
      key: "county",
      name: "County",
      dataSource: "name",
      sortable: true,
    }
  ]

  return (
    <div className="territory-assignments-card-container">
      <MGrid
        data={assignedRegions}
        isFetchingData={isFetchingRegions}
        columnDefinitions={columnDefs}
        cardStyle
        headerText="Territory Assignments"
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  makeErrorToast(text: string) {
    responseHandler.customToast(text, "error", dispatch);
  },
});

export default connect(null, mapDispatchToProps)(TerritoryAssignmentsCard);